import { useEffect, useRef, useState } from "react"
import { ErrorCard, MainContainer } from "../../components"
import NextInputBox from "../../components/InputBox"
import { Select, Button, Modal, ModalBody, ModalContent, ModalHeader, Card, CardBody, CardFooter, SelectItem, useDisclosure, ModalFooter, Autocomplete, AutocompleteItem, Chip, Checkbox } from "@heroui/react"
import { useFetchWithBody, useGet, usePost } from "../../api/reactQueryCustomHooks"
import { ENUM_INPUT_TYPE, apiRoute, linksUrl } from "../../constants/enum"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { resetAcInfo, resetDetail, setAcInfo } from "../../state/accountSlice"
import Broker from "./Broker"
import DeliveryAddress from "./DeliveryAddress"
import Transport from "./Transport"
import { nextWednesday } from "date-fns"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCancel, faFile, faSave } from "@fortawesome/free-solid-svg-icons"
import { scrollInput, stickyBottomClass, stickyParentClass } from "../../Utility/utility"

const ENUM_BANK_ACTYPE = [
    { key: "", value: "Bank A/C Type" },
    { key: "C", value: "Current A/C" },
    { key: "S", value: "Saving A/C" }
]
const ENUM_PACKATETYPE = [
    { key: "MIX", value: "Mix" },
    { key: "SNG", value: "Single" },
]
const Enum_BTN_TYPE = {
    Transport: "Transport",
    DeliveryAdd: "Delivery Address",
    Broker: "Broker",
    GstInfo: "Gst Details"
}
const ENUM_OP_BALACE_TYPE = [
    { value: "Cr", key: "C" },
    { value: "Dr", key: "D" }
]
const ENUM_MSME_TYPE = [
    { value: "MSME Type", key: "" },
    { value: "Micro", key: "Micro" },
    { value: "Small", key: "Small" },
    { value: "Mini", key: "Mini" }
]
const CreateAccountMaster = () => {
    const { compCode, isMultipleCompany, gstNo } = useSelector((state) => state.company)
    let { user } = useSelector((state) => state.auth)
    const { detail, isNewEntry, redirectLink } = useSelector(
        (state) => state.account
    )
    const submitLockRef = useRef(false)
    let [entryLabel, setEntryLabel] = useState("")
    const [isReplicateEntry, setIsReplicateEntry] = useState(0)
    const [submitBtnId, setSubmitBtnId] = useState("")
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

    }, [])

    const {
        isOpen: isOpenReportModel,
        onOpen: onOpenReportModel,
        onOpenChange: onOpenReportModelChange,
    } = useDisclosure()
    let navigate = useNavigate();
    let dispatch = useDispatch();
    let [btnType, setBtnType] = useState("");
    let [btnDisable, setBtnDisable] = useState(true);
    const { isError: isErrorFetch, data: dataPartyTradeState = [] } = useFetchWithBody({
        url: apiRoute.account.masterPartyTradeState,
        queryKey: "masterPartyStateTrade"
    })
    const { isError: isErrorMastType, data: dataTypeProcesGroup = [] } = useFetchWithBody({
        url: apiRoute.account.masterTypeProcess,
        queryKey: "masterTypeProcess",
        inputData: {
            compcode: compCode.join(","),
        }
    })


    const formField = {
        accountId: "accountId",
        description: "description",
        commonId: "commonId",
        acType: "acType",
        underGroup: "underGroup",
        process: "process",
        tradeOf: "tradeOf",
        forType: "forType",
        gstType: "gstType",
        partyType: "partyType",
        openingBal: "openingBal",
        OpeningBalType: "OpeningBalType",
        currentBal: "currentBal",
        interest: "interest",
        profit: "profit",
        payDueDays: "payDueDays",
        partyGroup: "partyGroup",
        transactionLimit: "transactionLimit",
        rate: "rate",
        disc: "disc",
        category: "category",
        accGroup: "accGroup",
        paymentTerm: "paymentTerm",
        voucherSeries: "voucherSeries",
        bankAcNo: "bankAcNo",
        bankAcType: "bankAcType",
        mailingName: "mailingName",
        contactNo1: "contactNo1",
        personName: "personName",
        contactNo2: "contactNo2",
        address1: "address1",
        mobileNo: "mobileNo",
        address2: "address2",
        emailId: "emailId",
        address3: "address3",
        url: "url",
        address4: "address4",
        city: "city",
        pinCode: "pinCode",
        panNo: "panNo",
        state: "state",
        distance: "distance",
        vatTinNo: "vatTinNo",
        country: "country",
        orderBy: "orderBy",
        cstNo: "cstNo",
        gstNo: "gstNo",
        regDate: "regDate",
        dlNo: "dlNo",
        msmeRegNo: "msmeRegNo",
        msmeType: "msmeType"
    }

    const NoField = [formField.interest, formField.underGroup, formField.process, formField.profit, formField.openingBal, formField.currentBal, formField.orderBy
        , formField.disc, formField.payDueDays, formField.transactionLimit, formField.rate, formField.distance, formField.pinCode
    ]

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (NoField.includes(key))
            acc[key] = 0;
        else if (key == formField.acType)
            acc[key] = "0";
        else if (key == formField.OpeningBalType)
            acc[key] = "D";
        else
            acc[key] = "";
        return acc;
    }, {});

    const [gstDetail, setGstDetail] = useState(null)
    const { mutate: funVerifyGstNo } = usePost({
        url: apiRoute.account.verifyGstDetail,
        queryKey: "verifyGstin",

        onSuccessTasks: (data) => {
            if (data && Object.keys(data).length > 0) {
                
                if (data.hasOwnProperty("error")) {
                    toast.error(data?.error?.message || "",{
                        position:"top-center"
                    })
                    return;
                }
                setGstDetail(data);
                setBtnType(Enum_BTN_TYPE.GstInfo);
                onOpenReportModel();
                

            }
            else {
                toast.error(" Unexpected error while fetching GST details Invalid GSTIN / UID  ", {
                    position: "top-center",
                    className: "toast-error"
                })
                setFormData({ ...formData, [formField.gstNo]: "" })
            }
        },
    });

    const handleGstVerify = () => {
        if (!formData.gstNo) {
            toast.error("Please enter GST No first");
            return;
        }

        const SearchGstin = formData.gstNo;
        const CompCode = compCode.join(",");
        const payload = {
            CompCode,
            SearchGstin
        }

        funVerifyGstNo({
            data: payload,
            onError: (error) => {
                //console.error("API Error:", error); // Debug log
                toast.error(error.message || "Failed to verify GST");
            }
        });

    }



    const reportModel = () => {
        return (
            <div>
                <Modal
                    isOpen={isOpenReportModel}
                    onOpenChange={onOpenReportModelChange}
                    size="xl"
                    placement="center"
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <ModalHeader className="flex flex-row gap-1">
                                    {btnType}
                                </ModalHeader>
                                <ModalBody className="overflow-auto ">
                                    <div className="flex flex-col">
                                        {btnType == Enum_BTN_TYPE.Broker ? <Broker /> :
                                            btnType == Enum_BTN_TYPE.Transport ? <Transport /> :
                                                btnType == Enum_BTN_TYPE.DeliveryAdd ? <DeliveryAddress /> :
                                                    btnType == Enum_BTN_TYPE.GstInfo && gstDetail ? (
                                                        <div className="grid grid-cols-1 gap-4">
                                                            <div className="grid grid-cols-2 gap-4">
                                                                <div>
                                                                    <p className="font-semibold">Trade Name:</p>
                                                                    <p>{gstDetail.tradeNam}</p>
                                                                </div>
                                                                <div>
                                                                    <p className="font-semibold">Legal Name:</p>
                                                                    <p>{gstDetail.lgnm}</p>
                                                                </div>
                                                            </div>
                                                            <div className="grid grid-cols-2 gap-4">
                                                                <div>
                                                                    <p className="font-semibold">GSTIN:</p>
                                                                    <p>{gstDetail.gstin}</p>
                                                                </div>
                                                                <div>
                                                                    <p className="font-semibold">Registration Date:</p>
                                                                    <p>{gstDetail.rgdt}</p>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <p className="font-semibold">Principal Address:</p>
                                                                {gstDetail && (
                                                                    <>
                                                                        <p>Add. 1: {gstDetail.pradr.addr.bno} {gstDetail.pradr.addr.bnm}</p>
                                                                        <p>Add. 2: {gstDetail.pradr.addr.st}</p>
                                                                        <p>Add. 3: {gstDetail.pradr.addr.loc}</p>
                                                                        <p>Add. 4: {gstDetail.pradr.addr.landMark}</p>
                                                                        <p>Add. 5: {gstDetail.pradr.addr.dst}</p>
                                                                        <p>Add. 6: {gstDetail.pradr.addr.stcd}</p>
                                                                        <p>Pincode: {gstDetail.pradr.addr.pncd}</p>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) :

                                                        ""}
                                    </div>
                                </ModalBody>
                                <ModalFooter>

                                    {btnType == Enum_BTN_TYPE.GstInfo && (
                                        <Button
                                            size="sm"
                                            color="success"
                                            onPress={() => {
                                                fillGstDetails();
                                                onClose();
                                            }}
                                        >
                                            Fill Details
                                        </Button>
                                    )}

                                    <Button color="danger" size="sm" variant="bordered" onPress={onClose}>
                                        Close
                                    </Button>
                                </ModalFooter>
                            </>

                        )}
                    </ModalContent>
                </Modal>
            </div >
        )
    }
    let [formData, setFormData] = useState({
        ...emptyFormField
    })
    const onSuccessCheckAcid = (data) => {
        if (!submitLockRef.current) return; // 🚫 ignore stale calls
        if (data && data.length > 0 && isNewEntry) {
            toast.error("Account ID exist use another ", {
                position: "top-center"
            })
            setFormData({ ...formData, accountId: "" })
            submitLockRef.current = false;
        }
        else {
            // const d = dataPartyTradeState.itemState.filter(ele => ele.State == )
            funInsert({
                data: {
                    datalist: [formData],
                    comp_code: compCode.join(","),
                    replicate_entry: isReplicateEntry,
                    rec_status: !isNewEntry ? 1 : 2,
                    user_id: user.username
                }
            })
        }
    }
    const { mutate: checkACID } = usePost({
        url: apiRoute.account.checkacid,
        queryKey: "checkAcid",
        onSuccessTasks: onSuccessCheckAcid
    })

    const handleInputChange = (e) => {
        const { name } = e.target;
        let value = e.target.value;
        if (name == formField.openingBal) {
            let bType = "D"
            if (value < 0) {
                bType = "C"
            }
            setFormData({ ...formData, OpeningBalType: bType })
        }
        else if (name == formField.accountId) {//set max length 6 for accountid
            if (value.length <= 6) {
                setFormData((prev) => ({
                    ...prev, [name]: value
                })
                )
            }
        }
        if (name == formField.accountId) {
            setFormData((prev) => ({
                ...prev, [name]: value.length > 6 ? value.substring(0, 6).toUpperCase() : value.toUpperCase()
            })
            )
        }
        else {
            setFormData((prev) => ({
                ...prev, [name]: value
            })
            )
        }
    }

    const onSuccessTasks = (data) => {
        if (data == 0) {
            // toast.success(isNewEntry ? "Account Inserted Successfully" : "Account Updated Successfully", {
            //     position: "top-center"
            // })
            // if (redirectLink && redirectLink != "")
            //     navigate(redirectLink)
            // else
            dispatch(resetDetail())
            dispatch(resetAcInfo())
            submitLockRef.current = false;
            if (submitBtnId == 'btnSaveNew') {
                setFormData({ ...emptyFormField })
                // window.location.reload();
                // navigate(linksUrl.master.account.createAccountMaster);

            }
            else {
                navigate(linksUrl.master.account.accountMaster)
                setBtnDisable(false)
                dispatch(setAcInfo({ acId: formData.accountId, isUpdate: isNewEntry }))
                dispatch(resetDetail())
            }

        }
        // submitLockRef.current = false;
    }
    const resetValues = () => {
        //if (isNewEntry)
        setFormData({})

    }
    const { isError, isPending, mutate: funInsert } = usePost({
        url: apiRoute.account.add,
        queryKey: "insertAccount",
        onSuccessTasks,
        resetValues
    })

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        let OPbal = formData.openingBal

        if (formData.OpeningBalType == "C" && formData.openingBal > 0)
            OPbal = "-" + formData.openingBal

        setFormData({ ...formData, openingBal: OPbal })
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        if (formData.accountId != "") {
            checkACID({
                data: {
                    comp_code: compCode.join(","),
                    ac_id: formData.accountId

                }
            })
        }

    }
    const handleAutoCompleteChange = (value, name) => {

        if (name == formField.acType) {
            const data = dataTypeProcesGroup.itemAcType.filter((ele) => ele.actypeid == value)
            setFormData({ ...formData, [name]: value, underGroup: data && data.length > 0 ? String(data[0].defgrpcode) : 0 })
        }
        else
            setFormData({ ...formData, [name]: value })

    }

    const inputBoxes = {
        Row1: [
            {
                name: formField.accountId,
                placeholder: "Account ID",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                name: formField.description,
                placeholder: "Description",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row2: [
            {

                name: formField.acType,
                placeholder: "A/C Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: dataTypeProcesGroup.itemAcType,
                itemkey: "actypeid",
                itemvalue: "actypename",
                isrequired: true,
            },
            {

                name: formField.underGroup,
                placeholder: "Under Group",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: dataTypeProcesGroup.itemUnGroup,
                itemkey: "GRP_CODE",
                itemvalue: "GRP_DESC",
                isrequired: true,
            },
        ],
        Row3: [
            {

                name: formField.process,
                placeholder: "Process",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: dataTypeProcesGroup.itemProcess,
                itemkey: "PROCESS",
                itemvalue: "PROC_DESC",
                isrequired: false,
            },
            {

                name: formField.tradeOf,
                placeholder: "Trade Of",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: dataPartyTradeState.itemTrade,
                itemkey: "Trade_Of",
                itemvalue: "Trade_Of_Desc",
                isrequired: false,
            },
            {

                name: formField.forType,
                placeholder: "For Packet Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: ENUM_PACKATETYPE,
                itemkey: "key",
                itemvalue: "value",
                isrequired: false,
            },
        ],
        Row2A: [
            {

                name: formField.gstType,
                placeholder: "GST Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: dataPartyTradeState.itemGstType,
                itemkey: "TypeID",
                itemvalue: "TypeDesc",
                isrequired: false,
            },
            {

                name: formField.partyType,
                placeholder: "Party Type",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: dataPartyTradeState.itemParty,
                itemkey: "TypeID",
                itemvalue: "TypeDesc",
                isrequired: false,
            },
        ],
        Row4: [
            {

                name: formField.openingBal,
                placeholder: "Opening Balance",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.OpeningBalType,
                placeholder: "-",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "-",
                isrequired: false,
                data: ENUM_OP_BALACE_TYPE,
                itemkey: "key",
                itemvalue: "value"
            },
            {

                name: formField.currentBal,
                placeholder: "Current Balance",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row4A: [
            {

                name: formField.interest,
                placeholder: "Interest %",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {

                name: formField.profit,
                placeholder: "Profit %",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {

                name: formField.payDueDays,
                placeholder: "Pay Due Days",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row5: [
            {

                name: formField.partyGroup,
                placeholder: "Party Group",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {

                name: formField.category,
                placeholder: "Category",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },],
        Row5A: [
            {

                name: formField.transactionLimit,
                placeholder: "Transaction Limit",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {

                name: formField.rate,
                placeholder: "Rate",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {

                name: formField.disc,
                placeholder: "Disc %",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row6: [
            {
                name: formField.accGroup,
                placeholder: "ACC Group",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.paymentTerm,
                placeholder: "Payment Terms",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.voucherSeries,
                placeholder: "Voucher Sesries",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row7: [
            {
                name: formField.bankAcNo,
                placeholder: "Bank Account No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.bankAcType,
                placeholder: "Bank Account Type",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: ENUM_BANK_ACTYPE,
                itemkey: "key",
                itemvalue: "value",
                isrequired: false,

            },
        ],
        Row8: [
            {
                name: formField.mailingName,
                placeholder: "Mailing Name",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.contactNo1,
                placeholder: "Contact No 1",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        row9: [
            {
                name: formField.personName,
                placeholder: "Person Name",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.contactNo2,
                placeholder: "Contact No 2",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row10: [
            {
                name: formField.address1,
                placeholder: "Address 1",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.mobileNo,
                placeholder: "Mobile No",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row11: [
            {
                name: formField.address2,
                placeholder: "Address 2",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.emailId,
                placeholder: "Email ID",
                type: ENUM_INPUT_TYPE.email,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row12: [
            {
                name: formField.address3,
                placeholder: "Address 3",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.url,
                placeholder: "URL (WWWW)",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row13: [
            {
                name: formField.address4,
                placeholder: "Address 4",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.city,
                placeholder: "City",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row14: [

            {
                name: formField.pinCode,
                placeholder: "Pincode",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.panNo,
                placeholder: "PAN No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row15: [
            {
                name: formField.state,
                placeholder: "State",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: dataPartyTradeState.itemState,
                itemkey: "State",
                itemvalue: "State",
                isrequired: false,
            },
        ],
        Row15A: [
            {
                name: formField.distance,
                placeholder: "Distance",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.vatTinNo,
                placeholder: "Vat Tin No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row16: [
            {
                name: formField.country,
                placeholder: "Country",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {
                name: formField.orderBy,
                placeholder: "Order By",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ],
        Row17: [
            {
                name: formField.cstNo,
                placeholder: "CST No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.gstNo,
                placeholder: "GST No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        ROw17A: [
            {
                name: formField.regDate,
                placeholder: "Reg. Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.dlNo,
                placeholder: "D.L.No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },],
        Row17B: [
            {
                name: formField.msmeRegNo,
                placeholder: "MSME Reg. No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                name: formField.msmeType,
                placeholder: "MSME Type",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: ENUM_MSME_TYPE,
                itemkey: "key",
                itemvalue: "value",
                isrequired: false,
            },

        ]
    }

    useEffect(() => {
        if (
            !isNewEntry &&
            detail?.length > 0
        ) {
            setEntryLabel("Update Account -" + detail[0]?.AC_ID)
            setBtnDisable(false)
            setFormData({
                accountId: detail[0]?.AC_ID ? detail[0]?.AC_ID : "",
                description: detail[0]?.AC_DESC ? detail[0]?.AC_DESC : "",
                commonId: "",
                acType: detail[0]?.AC_TYPE ? detail[0]?.AC_TYPE : "",
                underGroup: detail[0]?.GRP_CODE ? String(detail[0]?.GRP_CODE) : "",
                process: detail[0]?.PROCESS ? detail[0]?.PROCESS : 0,
                tradeOf: detail[0]?.TRADE_OF ? detail[0]?.TRADE_OF : "",
                gstType: detail[0]?.EXP_TYPE ? detail[0]?.EXP_TYPE : "",
                partyType: detail[0]?.PARTY_TYPE ? detail[0]?.PARTY_TYPE : "",
                openingBal: detail[0]?.OPBAL ? detail[0]?.OPBAL : 0,
                OpeningBalType: detail[0]?.OPBAL ? detail[0]?.OPBAL > 0 ? "D" : "C" : "",
                currentBal: detail[0]?.CBAL ? detail[0]?.CBAL : 0,
                interest: detail[0]?.ROI ? detail[0]?.ROI : 0,
                profit: detail[0]?.PPER ? detail[0]?.PPER : 0,
                payDueDays: detail[0]?.PAYDUEDAYS ? detail[0]?.PAYDUEDAYS : 0,
                partyGroup: detail[0]?.PAR_GROUP ? detail[0]?.PAR_GROUP : "",
                transactionLimit: detail[0]?.TRANLIMIT ? detail[0]?.TRANLIMIT : 0,
                rate: detail[0]?.ITEM_RATE ? detail[0]?.ITEM_RATE : 0,
                disc: detail[0]?.DISC_PER ? detail[0]?.DISC_PER : 0,
                category: detail[0]?.LAC_ID ? detail[0]?.LAC_ID : "",
                accGroup: detail[0]?.AC_GROUP ? detail[0]?.AC_GROUP : "",
                paymentTerm: detail[0]?.PAY_TERMS ? detail[0]?.PAY_TERMS : "",
                voucherSeries: detail[0]?.IC_VNO ? detail[0]?.IC_VNO : "",
                bankAcNo: detail[0]?.BAC_NO ? detail[0]?.BAC_NO : "",
                bankAcType: detail[0]?.BAC_TYPE ? detail[0]?.BAC_TYPE : "",
                mailingName: detail[0]?.MAIL_DESC ? detail[0]?.MAIL_DESC : "",
                contactNo1: detail[0]?.CONTECTNO1 ? detail[0]?.CONTECTNO1 : "",
                personName: detail[0]?.PER_NAME ? detail[0]?.PER_NAME : "",
                contactNo2: detail[0]?.CONTECTNO2 ? detail[0]?.CONTECTNO2 : "",
                address1: detail[0]?.ADD_1 ? detail[0]?.ADD_1 : "",
                mobileNo: detail[0]?.CONTECTNO3 ? detail[0]?.CONTECTNO3 : "",
                address2: detail[0]?.ADD_2 ? detail[0]?.ADD_2 : "",
                emailId: detail[0]?.EMAIL_ID ? detail[0]?.EMAIL_ID : "",
                address3: detail[0]?.ADD_3 ? detail[0]?.ADD_3 : "",
                url: detail[0]?.URL ? detail[0]?.URL : "",
                address4: detail[0]?.ADD_4 ? detail[0]?.ADD_4 : "",
                city: detail[0]?.ADD_5 ? detail[0]?.ADD_5 : "",
                pinCode: detail[0]?.PINCODE ? detail[0]?.PINCODE : 0,
                panNo: detail[0]?.IT_NO ? detail[0]?.IT_NO : "",
                state: detail[0]?.ADD_6 ? detail[0]?.ADD_6 : "",
                distance: detail[0]?.DISTANCE ? detail[0]?.DISTANCE : 0,
                vatTinNo: detail[0]?.ST_NO ? detail[0]?.ST_NO : "",
                country: detail[0]?.COUNTRY ? detail[0]?.COUNTRY : "",
                orderBy: detail[0]?.ORD ? detail[0]?.ORD : 0,
                cstNo: detail[0]?.CST_NO ? detail[0]?.CST_NO : "",
                gstNo: detail[0]?.GST_NO ? detail[0]?.GST_NO : "",
                regDate: detail[0]?.ST_DATE ? new Date(detail[0]?.ST_DATE).toISOString().split("T")[0] : "",
                dlNo: detail[0]?.DLNO ? detail[0]?.DLNO : "",
                msmeRegNo: detail[0]?.EXCREGNO ? detail[0]?.EXCREGNO : "",
                msmeType: detail[0]?.EXCDIVISION ? detail[0]?.EXCDIVISION : "",
                forType: detail[0]?.FOR_TYPE ? detail[0]?.FOR_TYPE : ""
            })
        } //set data on edit
        else {
            setEntryLabel("Add New Account ")
        }
    }, [detail, isNewEntry])
    const handleClickPrev = () => {
        dispatch(resetDetail())
        dispatch(resetAcInfo())
        navigate(linksUrl.master.account.accountMaster)
    }
    const handelButton = (type) => {
        setBtnType(type);
        onOpenReportModel();
    }

    const handleSelectionChange = (e) => {
        const { value, name } = e.target


        setFormData((prev) => ({
            ...prev, [name]: value
        }))

    }
    const fillGstDetails = () => {
        if (!gstDetail) return;

        const addr = gstDetail.pradr?.addr || {};
        const d = dataPartyTradeState.itemState.filter(ele => ele.State == addr.stcd)
        // console.log(d,dataPartyTradeState.itemState)

        setFormData(prev => ({
            ...prev,
            [formField.description]: gstDetail.tradeNam || "",
            [formField.personName]: gstDetail.lgnm || "",
            [formField.regDate]: gstDetail.rgdt ? formatDate(gstDetail.rgdt) : "",
            [formField.address1]: `${addr.bno || ""} ${addr.bnm || ""}`.trim(),
            [formField.address2]: addr.st || "",
            [formField.address3]: addr.loc || "",
            [formField.address4]: addr.landMark || "",
            [formField.city]: addr.dst || "",
            [formField.state]: addr.stcd || "",
            [formField.pinCode]: addr.pncd || 0,
            [formField.country]: "India"
        }));
    };
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split('/');
        if (parts.length === 3) {
            return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
        }
        return "";
    };
    const duvref = useRef(null)
    useEffect(() => {
        const cleanup = scrollInput({ ignoreRefs: [duvref] });
        return () => cleanup();
    }, []);
    // const [isSticky, setIsSticky] = useState(false);

    // useEffect(() => {
    //     const handleScroll = () => {
    //         setIsSticky(window.scrollY > 30);
    //     };

    //     window.addEventListener("scroll", handleScroll);
    //     return () => window.removeEventListener("scroll", handleScroll);
    // }, []);
    if (isError || isErrorFetch || isErrorMastType) {
        return <ErrorCard />
    }
    return (
        <div>
            {reportModel()}
            <MainContainer pageName={`${isNewEntry ? "New" : "Update"} Account Entry`} info={[]} breadcrumbs={["Master", "Account Master"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                {/* <h4 className="mb-4 text-center  font-bold leading-none tracking-tight text-gray-900 md:text-md lg:text-md dark:text-white" >
                    {entryLabel}</h4> */}
                <Card shadow="sm" radius="sm" className={stickyParentClass}>

                    <form onSubmit={handleSubmit}>
                        <CardBody className="p-2">
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className="flex  items-end gap-2 mb-5 " key={ind} >
                                            {inputBoxes[key].map((item, index) => item.type == ENUM_INPUT_TYPE.select ? (

                                                <Select
                                                    name={item.name}
                                                    size="sm"
                                                    label={item.placeholder}
                                                    labelPlacement="outside"
                                                    placeholder="---select---"
                                                    selectionMode="single"
                                                    isVirtualized
                                                    isRequired={item.isrequired}
                                                    items={item.data ? item.data : []}
                                                    onChange={handleSelectionChange}
                                                    variant="flat"
                                                    color="default"
                                                    selectedKeys={[String(formData[item.name])]}
                                                >
                                                    {(list) => {
                                                        return (
                                                            <SelectItem key={list[item.itemkey]}>
                                                                {list[item.itemvalue]}
                                                            </SelectItem>)

                                                    }}
                                                </Select>
                                            ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (<Autocomplete
                                                size="md"

                                                name={item.name}
                                                //isInvalid={errors[item.name]}
                                                // errorMessage={errors[item.name]}
                                                label={item?.placeholder}
                                                eventResizeFeature={true}
                                                selectionMode="single"
                                                showScrollIndicators={true}
                                                labelPlacement={"outside"}
                                                placeholder={item.placeholder}
                                                isRequired={item.isrequired}
                                                menuTrigger="input"
                                                variant="flat"
                                                color="warning"
                                                //isLoading={isLoadingData}
                                                className="max-w-23"
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}
                                                isClearable={false}
                                                isVirtualized
                                                readonly={isNewEntry ? false : true}
                                                defaultItems={
                                                    item.data ? item.data : []
                                                }
                                                onSelectionChange={(e) =>
                                                    handleAutoCompleteChange(e, item.name)
                                                }
                                                //onChange={handleFormSelectionChange}
                                                selectedKey={formData[item.name]}
                                            >
                                                {(list) => (
                                                    <AutocompleteItem

                                                        key={list[item.itemkey]}
                                                    >
                                                        {list[item.itemvalue]}
                                                    </AutocompleteItem>
                                                )}
                                            </Autocomplete>)

                                                : (
                                                    <>
                                                        <NextInputBox
                                                            placeholder={item.placeholder}
                                                            value={formData[item.name]}
                                                            required={item.isrequired}
                                                            name={item.name}
                                                            type={item.type}
                                                            size={item.size}
                                                            readonly={item.name == formField.accountId && !isNewEntry ? true : false}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            onChange={handleInputChange}
                                                        />
                                                        {gstNo && gstNo != "" && item.name == formField.cstNo ? <Chip color="danger" size="sm" className="cursor-pointer" onClick={handleGstVerify} >Verify Gst No</Chip> : ""}
                                                    </>
                                                )
                                            )}
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="flex  items-center gap-2 mb-5">
                                <Button color="primary" size="sm" isDisabled={btnDisable} onPress={() => handelButton(Enum_BTN_TYPE.Transport)} >
                                    Trasnport
                                </Button>
                                <Button color="success" size="sm" isDisabled={btnDisable} onPress={() => handelButton(Enum_BTN_TYPE.Broker)} >
                                    Broker
                                </Button>
                                <Button color="warning" size="sm" isDisabled={btnDisable} onPress={() => handelButton(Enum_BTN_TYPE.DeliveryAdd)} >
                                    Delivery Address
                                </Button>
                            </div>

                            <Checkbox isSelected={isReplicateEntry} onValueChange={setIsReplicateEntry} color="primary">Replicate in each company</Checkbox>
                        </CardBody>

                        {/* Your scrollable form/content above */}

                        {/* Sticky Footer */}
                        <div className={stickyBottomClass}>
                            <div className="justify-center flex items-center gap-4">
                                <Button
                                    id="btnSave"
                                    color="primary"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="uppercase font-semibold"
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white uppercase font-semibold"
                                    startContent={<FontAwesomeIcon className="text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    className="uppercase font-semibold"
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>

                    </form>


                </Card>
            </MainContainer >
        </div >
    )
}
export default CreateAccountMaster